import type { DrawnGeometry } from '../../types/geo'
import { ddToMgrs, formatMgrs } from './mgrs'
import { formatDDPair, formatDMSPair, ddToDms } from './formats'

/**
 * Token resolvers that auto-fill template fields from a drawn geometry.
 * Returns a map of fieldId → auto-filled value.
 */
export function resolveAutoFill(
  fieldType: string,
  geometry: DrawnGeometry
): unknown {
  const { centroid, geojson, bbox } = geometry
  const [lon, lat] = centroid // [lon, lat] - GeoJSON order

  switch (fieldType) {
    case 'coordinate_dd':
      return { lat, lon }

    case 'coordinate_mgrs': {
      const mgrs = ddToMgrs(lat, lon)
      return mgrs ? formatMgrs(mgrs) : ''
    }

    case 'coordinate_any':
      return formatDDPair(lat, lon)

    case 'coordinate_dms': {
      const dms = {
        format: 'dms' as const,
        lat: ddToDms(lat, 'lat'),
        lon: ddToDms(lon, 'lon'),
      }
      return formatDMSPair(dms)
    }

    case 'geojson_polygon':
    case 'geojson_point':
    case 'geojson_linestring':
    case 'geojson_geometry':
      return geojson

    case 'bbox':
      return bbox ?? null

    default:
      return undefined
  }
}
